<template>
  <div class="resume-wrapper">
    <a class="resume-download" :href="getResume()" download>{{text}}</a>
  </div>
</template>

<script>
export default {
  name: 'Resume',
  componentName: "resume",
  data() {
    return {
      text: 'Download CV',
    };
  },
  methods: {
    getResume() {
      let path = require('../assets/Mine_CV_2_25.pdf')
      return path
    }
  }
};
</script>

<style lang="sass-loader">
@import '../assets/styles/main.scss';
  .resume {
    &-download {
      text-decoration: underline;
      font-size: 18px;
    }
  @include breakpoint(mobile) {
      &-download {
        font-size: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Resume.vue